"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconMail', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M2,15 L2,6.045 L9.386,11.789 C9.566,11.93 9.783,12 10,12 C10.217,12 10.434,11.93 10.614,11.789 L18,6.045 L18,15 L2,15 Z M16.086,5 L10,9.733 L3.914,5 L16.086,5 Z M19.976,3.88 C19.968,3.812 19.958,3.746 19.936,3.68 C19.912,3.612 19.879,3.554 19.843,3.494 C19.822,3.459 19.815,3.419 19.789,3.386 C19.776,3.369 19.757,3.362 19.744,3.347 C19.697,3.293 19.643,3.253 19.585,3.211 C19.536,3.174 19.49,3.137 19.437,3.11 C19.381,3.083 19.322,3.069 19.262,3.053 C19.194,3.034 19.129,3.017 19.06,3.012 C19.039,3.011 19.021,3 19,3 L1,3 C0.979,3 0.962,3.011 0.94,3.012 C0.871,3.017 0.807,3.034 0.739,3.053 C0.679,3.069 0.619,3.083 0.563,3.11 C0.51,3.137 0.465,3.174 0.416,3.209 C0.358,3.252 0.304,3.293 0.256,3.347 C0.242,3.362 0.224,3.369 0.211,3.386 C0.185,3.419 0.178,3.459 0.156,3.494 C0.121,3.555 0.088,3.612 0.064,3.679 C0.042,3.746 0.032,3.812 0.024,3.88 C0.02,3.921 0,3.957 0,4 L0,16 C0,16.553 0.447,17 1,17 L19,17 C19.553,17 20,16.553 20,16 L20,4 C20,3.957 19.98,3.921 19.976,3.88 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;